
import { StrapiImage } from "@/types/home";

const API_URL = process.env.NEXT_PUBLIC_API_URL || "";

type FormatSize = "thumbnail" | "small" | "medium" | "large";
type Size = FormatSize | "original";

const SIZE_ORDER: FormatSize[] = [
    "thumbnail",
    "small",
    "medium",
    "large",
];

function absolutize(url: string): string {
    if (!url) return url;

    if (url.startsWith("http://") || url.startsWith("https://")) {
        return url;
    }

    return `${API_URL}${url}`;
}

export function getStrapiImageUrl(
    image: StrapiImage | null | undefined,
    preferred: Size = "large"
): string | null {
    if (!image?.url) return null;

    if (preferred === "original") {
        return absolutize(image.url);
    }

    const fmt = image.formats?.[preferred];

    if (fmt?.url) {
        return absolutize(fmt.url);
    }

    const idx = SIZE_ORDER.indexOf(preferred);

    for (let i = idx - 1; i >= 0; i--) {
        const f = image.formats?.[SIZE_ORDER[i]];

        if (f?.url) return absolutize(f.url);
    }

    for (let i = idx + 1; i < SIZE_ORDER.length; i++) {
        const f = image.formats?.[SIZE_ORDER[i]];

        if (f?.url) return absolutize(f.url);
    }

    return absolutize(image.url);
}

export function getStrapiImageAlt(
    image: StrapiImage | null | undefined,
    fallback?: string
): string {
    return image?.alternativeText || fallback || "";
}
